<template>
	<div>
		<div class="chat-message " v-for="answer in answers" :key="answer.id">
			<header class="flex-row flex-center-v flex-align-spaced">
				<div class="user-card">
					<picture :class="user_is_expert || user_is_coordinator ? 'expert-avatar' : 'avatar'">
						<img
							role="img"
							:src="answer.user.avatar"
							:alt="`${answer.user.firstname[0]}${answer.user.lastname[0]}`"
							width="60"
							height="60"
						/>
					</picture>
					<div>
						<header>{{ answer.user.firstname }} {{ answer.user.lastname }}</header>
						<footer>{{ answer.user.specialty }}</footer>
					</div>
				</div>

				<small class="date">Le {{ answer.date_modified }}</small>
			</header>
			<p class="message" v-html="answer.details"></p>
		</div>
	</div>
</template>

<style lang="scss" scoped>
details {
	text-align: right;
}
.message {
	margin-left: 58px;
	border-left: 2px solid #ccc;
	padding: 0 1em;
}

.expert-avatar {
	img {
		object-fit: contain;
	}
}
</style>

<script>
export default {
	name: "AnswersChat",
	props: ["user", "question", "answers"],

	computed: {
		// Is the user a coordinator? (role 3)
		user_is_coordinator: function() {
			return this.user.roles.indexOf(3) !== -1;
		},
		// Is the user an expert? (role 2)
		user_is_expert: function() {
			return this.user.roles.indexOf(2) !== -1;
		}
	}
};
</script>
